import { flattenObject } from '@/utils';

import common from './common';
import menu from './menu';
import permission from './permission';

import usersUsers from './pages/users-users';
import usersOverview from './pages/users-overview';
import registrationChannels from './pages/registration-channels';
import featuresOverview from './pages/features-overview';
import systemManagementAccounts from './pages/system-management_accounts';
import systemManagementLogs from './pages/system-management_logs';
import systemManagementExports from './pages/system-management_exports';
import roleManagement from './pages/role-management';
import serviceConfig from './pages/service-config';
import dramaReview from './pages/drama-review';
import ugcReports from './pages/ugc-reports';
import comments from './pages/comments';
import clientBanner from './pages/client-banner';
import miningWeeklyRewards from './pages/mining-weekly-rewards';
import shareReview from './pages/share-review';
import userStories from './pages/user-stories';
import activity1011Config from './pages/activity-1011-config';
import appVersionUpdates from './pages/app-version-updates';
import contentFilter from './pages/content-filter';
import trust from './trust';

import oldCommon from './modules/common';
import oldMenu from './modules/menu';

export default {
    ...flattenObject(common),
    ...flattenObject(menu),
    ...flattenObject(permission),

    ...flattenObject(usersUsers),
    ...flattenObject(usersOverview),
    ...flattenObject(registrationChannels),
    ...flattenObject(featuresOverview),
    ...flattenObject(systemManagementAccounts),
    ...flattenObject(systemManagementLogs),
    ...flattenObject(systemManagementExports),
    ...flattenObject(roleManagement),
    ...flattenObject(serviceConfig),
    ...flattenObject(dramaReview),
    ...flattenObject(ugcReports),
    ...flattenObject(comments),
    ...flattenObject(clientBanner),
    ...flattenObject(miningWeeklyRewards),
    ...flattenObject(shareReview),
    ...flattenObject(userStories),
    ...flattenObject(activity1011Config),
    ...flattenObject(appVersionUpdates),
    ...flattenObject(contentFilter),
    ...flattenObject(trust),

    ...oldCommon,
    ...oldMenu,
};
